import { render, staticRenderFns } from "./TopTabBar.vue?vue&type=template&id=4a5bac7e&scoped=true&"
import script from "./TopTabBar.vue?vue&type=script&lang=js&"
export * from "./TopTabBar.vue?vue&type=script&lang=js&"
import style0 from "./TopTabBar.vue?vue&type=style&index=0&id=4a5bac7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5bac7e",
  null
  
)

export default component.exports